import BaseSelectroPresenter from './BaseSelectroPresenter';
import {
  type SelectroTemplates,
  type SelectroText,
} from '@aha-app/selectro-v2';
import InitiativeItemTemplate from '../Templates/Initiatives/InitiativeItemTemplate';
import terminology from 'javascripts/terminology';

// This is the definition for the initiatives SelectroPresenter,
// to use it import InitiativesSelectroPresenter from SelectroPresenters/index.ts
// that file exports the singleton instance of this class.
class InitiativesSelectroPresenterDefinition extends BaseSelectroPresenter {
  baseTemplates(): SelectroTemplates {
    return {
      item: InitiativeItemTemplate,
    };
  }

  baseText(): SelectroText {
    return {
      searchPlaceholder: `Search by name or ${terminology('product')}`,
    };
  }
}

export default InitiativesSelectroPresenterDefinition;
